import {ICommonSavePayload} from '../Common.actions';
import {ContentItemEdit} from '../../types/requests/ContentItemEdit';
import {AxiosResponse} from 'axios';
import authenticatedApi from '../../@template/services/auth/authApi/authenticatedApi';
import {coreApiConfig} from '../../config';
import {ContentItem} from '../../types/models/ContentItem';
import {all, call, put, takeEvery} from '@redux-saga/core/effects';
import {
  CONTENT_ITEM_SEARCH,
  contentItemLoadError,
  contentItemLoadSuccess, CONTENT_ITEMS,
  contentItemSaveError,
  contentItemSaveSuccess, contentItemSearchError,
  contentItemSearchSuccess
} from './Actions';
import {parseErrorInfo, parseErrorToErrorClass} from '../../@template/helpers/errors';
import {SearchRequest} from '../../types/common/SearchRequest';
import {ContentItemSearchRequest} from '../../types/requests/ContentItemSearchRequest';
import {PagedEntityListOfContentItemSearchItem} from '../../types/views/PagedEntityListOfContentItemSearchItem';
import {PayloadAction} from '@reduxjs/toolkit';

export function* SaveContentItem({ id, submission }: ICommonSavePayload<ContentItemEdit>) {
  console.log('SAGA - contentItemSaga - SaveContentItem');
  try {
    const res: AxiosResponse = yield authenticatedApi.request({
      baseURL: coreApiConfig.Url,
      method: id ? 'PUT' : 'POST',
      url: id ? `${coreApiConfig.Paths.contentItem}/${id}` : coreApiConfig.Paths.contentItem,
      data: submission
    });
    const contentItem: ContentItem = ContentItem.fromJS(res.data);
    yield put(contentItemSaveSuccess(contentItem));
  } catch (err) {
    yield put(contentItemSaveError(parseErrorToErrorClass(err)));
  }
}


export function* LoadContentItem(id: string) {
  console.log('SAGA - contentItemSaga - LoadContentItem');
  try {
    const res: AxiosResponse = yield authenticatedApi.request({
      baseURL: coreApiConfig.Url,
      method: 'GET',
      url: `${coreApiConfig.Paths.contentItem}/${id}`,
    });
    const contentItem: ContentItem = ContentItem.fromJS(res.data);
    yield put(contentItemLoadSuccess(contentItem));
  } catch (err) {
    yield put(contentItemLoadError(parseErrorInfo(err)));
  }
}

export function* SearchContentItems({ page, pageSize, searchParams, sortBy, sortDirection }: SearchRequest<ContentItemSearchRequest>) {
  console.log('SAGA - contentItemSaga - SearchContentItems');
  try {
    const res: AxiosResponse = yield authenticatedApi.request({
      baseURL: coreApiConfig.Url,
      method: 'PUT',
      url: `${coreApiConfig.Paths.contentItem}/search?page=${page}&page_size=${pageSize}&sort=${sortBy}&order=${sortDirection}`,
      data: searchParams
    });
    const results: PagedEntityListOfContentItemSearchItem = PagedEntityListOfContentItemSearchItem.fromJS(res.data);
    yield put(contentItemSearchSuccess(results));
  } catch (err) {
    yield put(contentItemSearchError(parseErrorInfo(err)));
  }
}

export function* watchSaveContentItem(){
  yield takeEvery(CONTENT_ITEMS.SAVE, ({ payload } : PayloadAction<ICommonSavePayload<ContentItemEdit>>) => SaveContentItem(payload));
}

export function* watchLoadContentItem(){
  yield takeEvery(CONTENT_ITEMS.LOAD, ({ payload } : PayloadAction<string>) => LoadContentItem(payload));
}

export function* watchRefreshContentItem(){
  yield takeEvery(CONTENT_ITEMS.REFRESH, ({ payload } : PayloadAction<string>) => LoadContentItem(payload));
}

export function* watchSearchContentItems(){
  yield takeEvery(CONTENT_ITEM_SEARCH.LOAD, ({ payload } : PayloadAction<SearchRequest<ContentItemSearchRequest>>) => SearchContentItems(payload));
}

export default function* contentItemSaga() {
  yield all ([
    call(watchSaveContentItem),
    call(watchRefreshContentItem),
    call(watchLoadContentItem),
    call(watchSearchContentItems),
  ])
}